export const MAX_DISPLAY_LOCATIONS = 10;
export const ELIGIBLE_CATEGORIES_L2 = ['seating', 'lighting', 'tables', 'storage-case-pieces'];
export const LOCATION_US_CODE = '001';

export const LOCATION_US_CITY_REGEXP = /^001\d{6}/;
export const LOCATION_US_REGEXP = /^001/;
